import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { PromoBannerType } from "@faire/retailer-visitor-shared/components/Notifications/PromoBanner/bannerOrder";
export var BannerSectionVariant;
(function(BannerSectionVariant) {
    BannerSectionVariant[BannerSectionVariant["FAIRE_DIRECT_INCENTIVES"] = 0] = "FAIRE_DIRECT_INCENTIVES";
    BannerSectionVariant[BannerSectionVariant["MARKET_COUNTDOWN"] = 1] = "MARKET_COUNTDOWN";
    BannerSectionVariant[BannerSectionVariant["FIRST_ORDER_INCENTIVES"] = 2] = "FIRST_ORDER_INCENTIVES";
    BannerSectionVariant[BannerSectionVariant["POST_FCO_BANNERS"] = 3] = "POST_FCO_BANNERS";
    BannerSectionVariant[BannerSectionVariant["ADDITIONAL_BANNERS"] = 4] = "ADDITIONAL_BANNERS";
    BannerSectionVariant[BannerSectionVariant["EMPLOYEE_GRANTED_FREE_FREIGHT"] = 5] = "EMPLOYEE_GRANTED_FREE_FREIGHT";
})(BannerSectionVariant || (BannerSectionVariant = {}));
export var ORDERED_FAIRE_DIRECT_BANNERS = [
    PromoBannerType.FAIRE_DIRECT_INCENTIVES
];
export var ORDERED_MARKET_COUNTDOWN_BANNERS = [
    PromoBannerType.MARKET_COUNTDOWN
];
// only section not in order
export var UNORDERED_FIRST_ORDER_INCENTIVES_BANNERS = [
    PromoBannerType.FIRST_ORDER_INCENTIVE,
    PromoBannerType.OPEN_WITH_FAIRE,
    PromoBannerType.PAYMENT_TERMS
];
// post-FCO -> should only show if POST_FCO_INCENTIVE_DISCOUNT_JUNE_2024 is part of array
export var ORDERED_POST_FCO_BANNERS = [
    PromoBannerType.POST_FCO_INCENTIVE_DISCOUNT_JUNE_2024,
    PromoBannerType.DISCOVERY_TERMS
];
// additional banners
export var ORDERED_ADDITIONAL_BANNERS = [
    PromoBannerType.POS_INTEGRATION,
    PromoBannerType.OPEN_WITH_FAIRE,
    PromoBannerType.SPECIAL_HOLIDAY_NET90,
    PromoBannerType.OPENING_ORDER_INCENTIVES,
    PromoBannerType.AMEX_INCENTIVE,
    PromoBannerType.WAREHOUSE_SALE,
    PromoBannerType.REFERRAL_FOLLOWUP,
    PromoBannerType.DISCOVERY_TERMS
];
export var ORDERED_EMPLOYEE_GRANTED_FREE_FREIGHT_BANNERS = [
    PromoBannerType.EMPLOYEE_GRANTED_FREE_FREIGHT
];
export var IMP_TO_PROMO_BANNER_MAP = {
    POST_FCO_INCENTIVE_DISCOUNT_JUNE_2024: PromoBannerType.POST_FCO_INCENTIVE_DISCOUNT_JUNE_2024,
    FIRST_ORDER_INCENTIVE: PromoBannerType.FIRST_ORDER_INCENTIVE,
    OPEN_WITH_FAIRE: PromoBannerType.OPEN_WITH_FAIRE,
    PAYMENT_TERMS: PromoBannerType.PAYMENT_TERMS,
    DISCOVERY_TERMS: PromoBannerType.DISCOVERY_TERMS
};
var _obj;
export var BANNERS_SECTION_WITH_ORDERED_BANNERS_MAP = (_obj = {}, _define_property(_obj, BannerSectionVariant.FAIRE_DIRECT_INCENTIVES, ORDERED_FAIRE_DIRECT_BANNERS), _define_property(_obj, BannerSectionVariant.MARKET_COUNTDOWN, ORDERED_MARKET_COUNTDOWN_BANNERS), // TODO: Will adjust for ordering
_define_property(_obj, BannerSectionVariant.FIRST_ORDER_INCENTIVES, UNORDERED_FIRST_ORDER_INCENTIVES_BANNERS), _define_property(_obj, BannerSectionVariant.POST_FCO_BANNERS, ORDERED_POST_FCO_BANNERS), _define_property(_obj, BannerSectionVariant.ADDITIONAL_BANNERS, ORDERED_ADDITIONAL_BANNERS), _define_property(_obj, BannerSectionVariant.EMPLOYEE_GRANTED_FREE_FREIGHT, ORDERED_EMPLOYEE_GRANTED_FREE_FREIGHT_BANNERS), _obj);
